import {
  Flex,
  HeaderContainer,
  HeaderIcon,
  IconClose,
  Typography,
} from '@banhala/ui-kit';

interface FolderOrderEditHeaderProps {
  onPressClose: () => void;
  onPressComplete: () => void;
  isCompleteEnabled: boolean;
}

export const FolderOrderEditHeader = ({
  onPressClose,
  onPressComplete,
  isCompleteEnabled,
}: FolderOrderEditHeaderProps) => {
  return (
    <HeaderContainer>
      <HeaderIcon onPress={onPressClose} customColor={'content_secondary'}>
        <IconClose />
      </HeaderIcon>
      <Flex.Center flex={1}>
        <Typography type={'h5'} color={'content_primary'}>
          서랍 순서 편집
        </Typography>
      </Flex.Center>
      <Flex.Center
        padding={{ horizontal: 16, vertical: 8 }}
        hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
        onPress={isCompleteEnabled ? onPressComplete : undefined}
      >
        <Typography
          type={'body1'}
          color={isCompleteEnabled ? 'content_blue_primary' : 'content_disabled'}
        >
          완료
        </Typography>
      </Flex.Center>
    </HeaderContainer>
  );
};
